import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import TicketSteps from "../../elements/tickets/ticket-steps";
import Intro from "../../elements/blocks/intro";
import TicketActivityForm from "../../elements/tickets/ticket-activity-form";
import TicketActivityHistory from "../../elements/tickets/ticket-activity-history";
import ContactHistoryViewModal from "../../elements/contacts/contact-history-view-modal";
import Nope from "../../elements/blocks/nope";
import { useApiTenant } from "../../../api/api-tenant";
export default function TicketActivity() {
    const { t } = useTranslation();
    const { id } = useParams();
    const api = useApiTenant();
    const [isLoading, setIsLoading] = useState(true);
    const [ticket, setTicket] = useState(null);
    const [openContactHistory, setOpenContactHistory] = useState(false);
    useEffect(() => {
        api.GET_ticket(id)
            .then(response => {
            setTicket(response.data.ticket);
            setIsLoading(false);
        })
            .catch(error => {
            if (!api.isCancel(error)) {
                console.error(error);
                setIsLoading(false);
            }
        });
        return () => api.cancel();
    }, []);
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: t("tickets.ticket") + " #" + id, breadcrumbs: [
                    {
                        name: t("campaigns.campaigns"),
                        link: "/campaigns",
                    },
                    {
                        name: ticket ? ticket.campaign.name : t("campaigns.campaign"),
                        link: "/campaigns/" + (ticket ? ticket.campaign.id : ""),
                    },
                    {
                        name: t("tickets.ticket") + " #" + id,
                        link: "/tickets/" + id,
                    },
                ], button: ticket && ticket.is_draft && !ticket.contact.is_anonymous
                    ? {
                        label: t("tickets.view-contact"),
                        action: () => setOpenContactHistory(true),
                        color: "outlined",
                        type: "edit",
                    }
                    : undefined, loading: isLoading }), isLoading ? (_jsx(Fragment, {})) : ticket ? (_jsxs(Fragment, { children: [_jsx(TicketSteps, { step: "activity", campaign: ticket.campaign, ticket: ticket }), _jsx(TicketActivityForm, { status: "new", ticket: ticket }), ticket.ticket_activities && ticket.ticket_activities.length > 0 && (_jsx(Box, Object.assign({ sx: {
                            marginTop: 4,
                        } }, { children: _jsx(TicketActivityHistory, { ticket: ticket }) }))), _jsx(ContactHistoryViewModal, { showContactModal: openContactHistory, setShowContactModal: setOpenContactHistory, campaign: ticket.campaign, contact: ticket.contact })] })) : (_jsx(Nope, { title: t("errors.404"), caption: t("tickets.ticket-not-found") }))] }));
}
